import { render, staticRenderFns } from "./editorComment.vue?vue&type=template&id=b4ce8550&"
import script from "./editorComment.vue?vue&type=script&lang=js&"
export * from "./editorComment.vue?vue&type=script&lang=js&"
import style0 from "./editorComment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports